/* Sheepskinhouse.co.uk shipping protection toggle (pilot 13-10-2026). Markup: snippets/ssh-protect.liquid.
   On  -> POST /cart/add.js    {id: protection variant, quantity: 1}
   Off -> POST /cart/change.js {id: line key, quantity: 0}
   After every cart mutation the line is reconciled: quantity is always 1, and it is removed when fewer than MIN_REAL real
   items are left (gift lines and fee lines are not real items). MIN_REAL = 1 since 13-10-2026 (free delivery is a Function
   that ignores fee lines) – keep in sync with min_real in snippets/ssh-protect.liquid. data-default-on="true" adds it once per session if the customer has not
   decided yet (default is false, see the snippet). UI refresh via Hyper's `cart:refresh` event (cart page: reload). */
(function () {
  var HANDLE = 'shipping-protection', TAG = 'ssh_protect=1', MIN_REAL = 1;
  var busy = false, again = false;
  function isFee(it) { return it.product_type === 'Fee' || it.product_type === 'mws_fee_generated' || !!(it.properties && it.properties._mws_fee); }
  function state(cart) {
    var line = null, real = 0;
    (cart.items || []).forEach(function (it) {
      if (it.handle === HANDLE) { line = it; return; }
      if (isFee(it) || (it.properties && it.properties._free_gift)) return;
      real += it.quantity;
    });
    return { line: line, real: real };
  }
  function box() { return document.querySelector('[data-ssh-protect]'); }
  function decided() { try { return sessionStorage.getItem('sshProtect'); } catch (e) { return null; } }
  function decide(v) { try { sessionStorage.setItem('sshProtect', v); } catch (e) {} }
  function mutate(url, payload) {
    return fetch(url + '?' + TAG, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function refreshUI() {
    try {
      if (/\/cart\/?$/.test(location.pathname)) { window.location.reload(); return; }
      var drawer = document.querySelector('cart-drawer');
      var open = !!(drawer && (drawer.classList.contains('open') || drawer.hasAttribute('open')));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: open } }));
      fetch('/cart.js?' + TAG).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    } catch (e) { console.log('ssh-protect refreshUI', e); }
  }
  function finish(changed) { busy = false; if (changed) refreshUI(); if (again) { again = false; setTimeout(reconcile, 120); } }
  /* sessionStorage: sshProtect = '1' / '0' (customer's own choice), 'auto' (added by default_on), absent (undecided);
     sshProtectHad = '1' while the line was in the cart at the last check (so a removal via the line's X counts as "no"). */
  function had() { try { return sessionStorage.getItem('sshProtectHad') === '1'; } catch (e) { return false; } }
  function setHad(v) { try { sessionStorage.setItem('sshProtectHad', v ? '1' : '0'); } catch (e) {} }
  function undecide() { try { sessionStorage.removeItem('sshProtect'); } catch (e) {} }
  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js?' + TAG).then(function (r) { return r.json(); }).then(function (cart) {
      var st = state(cart), b = box();
      if (st.line && st.real < MIN_REAL) {          /* too few real items: take it out again; an automatic add may come back later */
        if (decided() === 'auto') undecide();
        setHad(false);
        return mutate('/cart/change.js', { id: st.line.key, quantity: 0 }).then(function () { finish(true); });
      }
      if (st.line && st.line.quantity > 1) { setHad(true); return mutate('/cart/change.js', { id: st.line.key, quantity: 1 }).then(function () { finish(true); }); }
      if (st.line) { setHad(true); return finish(false); }
      if (had() && st.real >= MIN_REAL) { decide('0'); setHad(false); return finish(false); }          /* removed via the line's X = customer said no */
      if (st.real >= MIN_REAL && b && b.getAttribute('data-default-on') === 'true' && decided() === null) {
        var v = parseInt(b.getAttribute('data-variant') || '', 10);
        if (v) return mutate('/cart/add.js', { id: v, quantity: 1 }).then(function (j) { if (j) { decide('auto'); setHad(true); } finish(!!j); });
      }
      finish(false);
    }).catch(function () { finish(false); });
  }
  document.addEventListener('change', function (e) {
    var inp = (e.target && e.target.classList && e.target.classList.contains('ssh-protect__input')) ? e.target : null;
    if (!inp) return;
    var b = inp.closest('[data-ssh-protect]');
    if (!b) return;
    if (busy) { inp.checked = !inp.checked; return; }
    busy = true; b.classList.add('is-busy');
    var want = inp.checked;
    var p = want
      ? mutate('/cart/add.js', { id: parseInt(b.getAttribute('data-variant') || '', 10), quantity: 1 })
      : fetch('/cart.js?' + TAG).then(function (r) { return r.json(); }).then(function (cart) { var st = state(cart); return st.line ? mutate('/cart/change.js', { id: st.line.key, quantity: 0 }) : null; });
    p.then(function () { decide(want ? '1' : '0'); setHad(want); b.classList.remove('is-busy'); busy = false; refreshUI(); setTimeout(reconcile, 250); })
     .catch(function () { b.classList.remove('is-busy'); busy = false; inp.checked = !want; });
  });
  /* any other cart mutation (quantity change, remove, gift auto-add): reconcile afterwards */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try { if (CART_MUTATION.test(url) && url.indexOf(TAG) === -1) p.then(function () { setTimeout(reconcile, 200); }, function () {}); } catch (e) {}
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) { this.__sshPUrl = url; return origOpen.apply(this, arguments); };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try { var u = this.__sshPUrl || ''; if (CART_MUTATION.test(u) && u.indexOf(TAG) === -1) this.addEventListener('load', function () { setTimeout(reconcile, 200); }); } catch (e) {}
    return origSend.apply(this, arguments);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  else setTimeout(reconcile, 400);
})();
